import _BaseAPIService from "./_BaseAPIService";

  const apiService = _BaseAPIService.instance;
const BranchService = {
  getList: async () => {
    const response = await apiService.get("/branchoffices",{
      page:1,
      pageSize:20
    });
    return response.data;
  },
    
}

export default BranchService
